import * as React from "react";
import { forwardRef } from "react";
const SvgShare = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M333 330a2.99 2.99 0 0 0-2.077.844l-4.96-2.48a1.8 1.8 0 0 0 0-.727l4.96-2.48A2.994 2.994 0 1 0 330 323a3 3 0 0 0 .037.363l-4.96 2.48a3 3 0 1 0 0 4.313l4.96 2.48A3 3 0 0 0 330 333a3 3 0 1 0 3-3m0-8a1 1 0 1 1-1 1 1 1 0 0 1 1-1m-10 7a1 1 0 1 1 1-1 1 1 0 0 1-1 1m10 5a1 1 0 1 1 1-1 1 1 0 0 1-1 1", style: {
  fill: "#009f87"
}, transform: "translate(-320 -320)" }));
const ForwardRef = forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
